/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ what: NonNullable<unknown> }} Overlap_Uses_UpInputs */

const en_overlap_uses_up = /** @type {(inputs: Overlap_Uses_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uses up ${i?.what}`)
};

const de_overlap_uses_up = /** @type {(inputs: Overlap_Uses_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verwertet ${i?.what}`)
};

/**
* | output |
* | --- |
* | "Uses up {what}" |
*
* @param {Overlap_Uses_UpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const overlap_uses_up = /** @type {((inputs: Overlap_Uses_UpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overlap_Uses_UpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_overlap_uses_up(inputs)
	return en_overlap_uses_up(inputs)
});